<template>
  <v-container fluid >
    <div oncopy="return false" oncut="return false" onpaste="return false">
      <v-row ref="contenedor">
        <v-col cols="12">
          
          <v-app-bar  fixed  class="mt-12 elevation-0">
            <v-row>
              <v-tabs
                dense
                class="mt-4"
                v-model="tab"
                align-with-title
              >
                <v-tabs-slider color="grey"></v-tabs-slider>

                <v-tab
                  v-for="(item,i) in items"
                  :key="i"
                >
                  <v-icon v-text="item.icon" left></v-icon>{{ item.name }}
                </v-tab>
              </v-tabs>

            </v-row>
          </v-app-bar>

        </v-col>

        <v-col cols="12">
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <embed :src="`https://support-smipack.com/viewer/web/viewer.html?file=`+verElPdf" width="100%" :height="tamanioDisplay - 130">
            </v-tab-item>
            <v-tab-item>
              <embed :src="`https://support-smipack.com/viewer/web/viewer.html?file=`+verElPdf2" width="100%" :height="tamanioDisplay - 130">
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="8" lg="6" class="py-0">
                      <v-card class="elevation-0">
                        <v-card-title primary-title class="py-0">
                          Resumen
                        </v-card-title>
                      </v-card>
                      <v-textarea
                        readonly
                        v-model="resumen"
                        outlined
                        label="Resumen"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    
                  </v-row>
                  <v-divider></v-divider>

                  <v-row class="py-0">
                    <v-col cols="12" sm="8" lg="6" class="py-0">
                      <v-card class="elevation-0">
                        <v-card-title primary-title class="py-0">
                          Características
                        </v-card-title>
                      </v-card>
                      <v-data-table
                        :headers="headers2"
                        :items="tabla"
                        class="elevation-0"
                        hide-default-footer
                        :items-per-page="11"
                      >
                        <template v-slot:item.valor="{ item }">
                          <div v-if="item.valor == 'Suministro eléctrico'">
                            true
                            <v-textarea v-model="item.valor"></v-textarea>
                          </div>
                          <div v-else>{{item.valor}}</div>
                        </template>
                      </v-data-table>
                    </v-col>
                  
                    <v-col cols="12" sm="8" lg="6">
                      <v-card class="elevation-0">
                        <v-card-title primary-title>
                          PDF
                        </v-card-title>
                        <v-card-text>
                          <embed :src="`https://support-smipack.com/viewer/web/viewer.html?file=https://support-smipack.com/pdf/`+pdfname" width="100%" height="450" v-if="pdfname != ''">
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-img :src="url + imagename" contain width="100%" :height="tamanioDisplay - 170" />
            </v-tab-item>

          </v-tabs-items>
        </v-col>
      </v-row>
    </div>

  </v-container>
</template>

<script>
import pdfvuer from 'pdfvuer'
import pdf2 from 'vue-pdf'
document.oncontextmenu = function(){return false}

  export default {
    components: {
      pdf: pdfvuer,
      pdf2,
    },
    data () {
      return {
        tab: null,
        items: [
          {name:'MANUAL'            , icon:'insert_drive_file' }, 
          {name:'DIAGRAMA D. PARTES', icon:'insert_drive_file' }, 
          {name:'CARACTERÍSTICAS'   , icon:'assignment' }, 
          {name:'OPERACION'         , icon:'settings'}
        ],

        verElPdf: '',
        verElPdf2: '',
        ayuda: false,

        docum1:'',
        docum2:'',
        detalle:'',
        verDocumento:'',

        creado: false,

        // ///////////////////////////////
        resumen:'',
        headers2: [
          {
            text: 'Especificaciones tecnicas',
            align: 'start',
            sortable: false,
            value: 'et',
          },
          { text: 'Valor', value: 'valor' },
        ],
        docum3:[],
        url:'',
        foto:'',
        imagename:'',
        pdfname:'',
        tabla:[
          {et:'Suministro eléctrico', valor: ''},
          {et:'Potencia electrica', valor: ''},
          {et:'Presión del aire comprimido', valor: ''},
          {et:'Consumo del aire comprimido', valor: ''},
          {et:'Barra soldadora', valor: ''},
          {et:'Altura máxima del paquete', valor: ''},
          {et:'Velocidad cintas transportadoras', valor: ''},
          {et:'Producción de hasta', valor: ''},
          {et:'Dimensiones máximas bobina film', valor: ''},
          {et:'Dimensiones de la máquina', valor: ''},
          {et:'Peso neto de la maquina', valor: ''},
        ],


      }
    },
    computed: {
      formattedZoom () {
          return Number.parseInt(this.scale * 80);
      },

      tamanioDisplay () {
        console.log(this.$vuetify.breakpoint)
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return this.$vuetify.breakpoint.height
          break;
          case 'sm': 
            return this.$vuetify.breakpoint.height
          break;
          case 'md':
            return this.$vuetify.breakpoint.height
          break;
          case 'lg':
            return this.$vuetify.breakpoint.height 
          break;
          case 'xl':
            return this.$vuetify.breakpoint.height
          break;
        }
      },
      
    },
    
    created(){
      this.url = this.$http.options.root + 'fotos/'
      this.idsubseries = this.$route.params.detalle.idsubseries
      this.docum1 = this.$route.params.detalle.docum1
      this.docum2 = this.$route.params.detalle.docum2
      this.verElPdf = 'https://support-smipack.com/pdf/' + this.docum1
      this.verElPdf2 = 'https://support-smipack.com/pdf/' + this.docum2
      this.openCarac(this.idsubseries)
    },


    methods: {


      openCarac(item){
        this.$http.get('clasificacion.categoria.subseries.caracteristicas/' + item).then(response=>{
          console.log(response.body)
          if(response.body != ''){
            this.modoCarac = 1
            this.resumen   = response.body.resumen
            this.pdfname = response.body.pdfname
            this.imagename = response.body.imagename
            this.tabla[0].valor = response.body.op1
            this.tabla[1].valor = response.body.op2
            this.tabla[2].valor = response.body.op3
            this.tabla[3].valor = response.body.op4
            this.tabla[4].valor = response.body.op5
            this.tabla[5].valor = response.body.op6
            this.tabla[6].valor = response.body.op7
            this.tabla[7].valor = response.body.op8
            this.tabla[8].valor = response.body.op9
            this.tabla[9].valor = response.body.op10
            this.tabla[10].valor = response.body.op11   
          }else{this.modoCarac = 2}
        }).catch(error=>console.log(error))
      },
    }
  }
</script>
